const filtersConfig = [
    {
        label: "Suchbegriff",
        labelChanges: "Suchbegriff",
        type: "searchquery",
        name: "query",
        active: "",
        showInitial: "",
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Kategorien",
        labelChanges: "",
        type: "category",
        name: "hierarchicalCategories",
        active: true,
        showInitial: true,
        position: 1,
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: [
            "hierarchicalCategories.lvl0",
            "hierarchicalCategories.lvl1",
            "hierarchicalCategories.lvl2",
            "hierarchicalCategories.lvl3",
        ],
    },
    {
        label: "Kategorie",
        labelChanges: "",
        type: "refinement",
        name: "hierarchicalCategories.lvl0",
        active: "",
        showInitial: "",
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Kategorie",
        labelChanges: "",
        type: "refinement",
        name: "hierarchicalCategories.lvl1",
        active: "",
        showInitial: "",
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Kategorie",
        labelChanges: "",
        type: "refinement",
        name: "hierarchicalCategories.lvl4",
        active: "",
        showInitial: "",
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Kategorie",
        labelChanges: "",
        type: "refinement",
        name: "hierarchicalCategories.lvl3",
        active: "",
        showInitial: "",
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Preis",
        labelChanges: "",
        type: "range",
        name: "priceNumeric",
        active: true,
        showInitial: true,
        position: 2,
        group: "",
        groupPosition: "",
        unit: "€",
        groupName: "",
        levels: "",
    },
    {
        label: "Hersteller",
        labelChanges: "",
        type: "checkbox",
        name: "detail_manufacturer",
        active: true,
        showInitial: true,
        position: 3,
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Serie",
        labelChanges: "",
        type: "checkbox",
        name: "property_series",
        active: true,
        showInitial: true,
        position: 4,
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Lieferzeitraum",
        labelChanges: "",
        type: "datepicker",
        name: "detail_shippingTimeInDays",
        active: true,
        showInitial: true,
        position: 5,
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Lieferland",
        labelChanges: "",
        type: "checkbox",
        name: "deliveryCountryDisplay",
        active: true,
        showInitial: true,
        position: 6,
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Farbe",
        labelChanges: "",
        type: "group",
        name: "group_color",
        active: true,
        showInitial: true,
        position: 7,
        group: [
            {
                label: "Hauptfarbe",
                labelChanges: "Hauptfarbe",
                type: "checkbox",
                name: "property_color",
                active: true,
                showInitial: true,
                position: "",
                group: "",
                groupPosition: 1,
                unit: "",
                groupName: "Farbe",
                levels: "",
            },
            {
                label: "Farbe Front",
                labelChanges: "",
                type: "checkbox",
                name: "property_colorFront",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 2,
                unit: "",
                groupName: "Farbe",
                levels: "",
            },
            {
                label: "Farbe Fußkreuz",
                labelChanges: "",
                type: "checkbox",
                name: "property_colorBase",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 3,
                unit: "",
                groupName: "Farbe",
                levels: "",
            },
            {
                label: "Farbe Gestell",
                labelChanges: "",
                type: "checkbox",
                name: "property_colorFrame",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 4,
                unit: "",
                groupName: "Farbe",
                levels: "",
            },
            {
                label: "Farbe Sitzschale",
                labelChanges: "",
                type: "checkbox",
                name: "property_colorSeatShell",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 5,
                unit: "",
                groupName: "Farbe",
                levels: "",
            },
            {
                label: "Farbe Tischplatte",
                labelChanges: "",
                type: "checkbox",
                name: "property_colorTableTop",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 6,
                unit: "",
                groupName: "Farbe",
                levels: "",
            },
            {
                label: "Außenfarbe",
                labelChanges: "",
                type: "checkbox",
                name: "property_colorExterior",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 7,
                unit: "",
                groupName: "Farbe",
                levels: "",
            },
        ],
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },

    {
        label: "Form",
        labelChanges: "",
        type: "group",
        name: "group_shape",
        active: true,
        showInitial: false,
        position: 8,
        group: [
            {
                label: "Grundform",
                labelChanges: "Grundform",
                type: "checkbox",
                name: "property_shape",
                active: true,
                showInitial: true,
                position: "",
                group: "",
                groupPosition: 1,
                unit: "",
                groupName: "Form",
                levels: "",
            },
            {
                label: "Gestellform",
                labelChanges: "",
                type: "checkbox",
                name: "property_frameShape",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 2,
                unit: "",
                groupName: "Form",
                levels: "",
            },
            {
                label: "Plattenform",
                labelChanges: "",
                type: "checkbox",
                name: "property_plateShape",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 3,
                unit: "",
                groupName: "Form",
                levels: "",
            },
            {
                label: "Stuhl Gestellform",
                labelChanges: "",
                type: "checkbox",
                name: "property_chairFrameShape",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 4,
                unit: "",
                groupName: "Form",
                levels: "",
            },
            {
                label: "Gestell",
                labelChanges: "",
                type: "checkbox",
                name: "property_frame",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 5,
                unit: "",
                groupName: "Form",
                levels: "",
            },
        ],
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },

    {
        label: "Maße",
        labelChanges: "",
        type: "group",
        name: "group_dimensions",
        active: true,
        showInitial: true,
        position: 9,
        group: [
            {
                label: "Breite mm",
                labelChanges: "",
                type: "checkbox",
                name: "property_widthMm",
                active: true,
                showInitial: true,
                position: "",
                group: "",
                groupPosition: 1,
                unit: "mm",
                groupName: "Maße",
                levels: "",
            },
            {
                label: "Tiefe mm",
                labelChanges: "",
                type: "checkbox",
                name: "property_depthMm",
                active: true,
                showInitial: true,
                position: "",
                group: "",
                groupPosition: 2,
                unit: "mm",
                groupName: "Maße",
                levels: "",
            },
            {
                label: "Länge mm",
                labelChanges: "",
                type: "checkbox",
                name: "property_lengthMm",
                active: true,
                showInitial: true,
                position: "",
                group: "",
                groupPosition: 3,
                unit: "mm",
                groupName: "Maße",
                levels: "",
            },
            {
                label: "Höhe mm",
                labelChanges: "",
                type: "checkbox",
                name: "property_heightMm",
                active: true,
                showInitial: true,
                position: "",
                group: "",
                groupPosition: 4,
                unit: "mm",
                groupName: "Maße",
                levels: "",
            },
            {
                label: "Sitzbreite mm",
                labelChanges: "",
                type: "checkbox",
                name: "property_seatWidthMm",
                active: true,
                showInitial: true,
                position: "",
                group: "",
                groupPosition: 5,
                unit: "mm",
                groupName: "Maße",
                levels: "",
            },
            {
                label: "Sitzhöhe mm",
                labelChanges: "",
                type: "checkbox",
                name: "property_seatHeightMm",
                active: true,
                showInitial: true,
                position: "",
                group: "",
                groupPosition: 6,
                unit: "mm",
                groupName: "Maße",
                levels: "",
            },
            {
                label: "Sitztiefe mm",
                labelChanges: "",
                type: "checkbox",
                name: "property_seatDepthMm",
                active: true,
                showInitial: true,
                position: "",
                group: "",
                groupPosition: 7,
                unit: "mm",
                groupName: "Maße",
                levels: "",
            },
            {
                label: "Höhen Einstellung",
                labelChanges: "",
                type: "checkbox",
                name: "property_heightAdjustment",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 8,
                unit: "",
                groupName: "Maße",
                levels: "",
            },
            {
                label: "Fachbreite mm",
                labelChanges: "",
                type: "checkbox",
                name: "property_shelfWidthMm",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 9,
                unit: "mm",
                groupName: "Maße",
                levels: "",
            },
            {
                label: "Rückenlehnenhöhe mm",
                labelChanges: "",
                type: "checkbox",
                name: "property_backrestHeightMm",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 11,
                unit: "mm",
                groupName: "Maße",
                levels: "",
            },
        ],
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },

    {
        label: "Material",
        labelChanges: "",
        type: "group",
        name: "group_materials",
        active: true,
        showInitial: false,
        position: 10,
        group: [
            {
                label: "Hauptmaterial",
                labelChanges: "",
                type: "checkbox",
                name: "property_material",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 3,
                unit: "",
                groupName: "Material",
                levels: "",
            },
            {
                label: "Ausführung Sitz",
                labelChanges: "",
                type: "checkbox",
                name: "property_seatVersion",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 1,
                unit: "",
                groupName: "Material",
                levels: "",
            },
            {
                label: "Ausführung Rücken",
                labelChanges: "",
                type: "checkbox",
                name: "property_backVersion",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 2,
                unit: "",
                groupName: "Material",
                levels: "",
            },

            {
                label: "Material Front",
                labelChanges: "",
                type: "checkbox",
                name: "property_frontMaterial",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 4,
                unit: "",
                groupName: "Material",
                levels: "",
            },
            {
                label: "Material Gestell",
                labelChanges: "",
                type: "checkbox",
                name: "property_materialFrame",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 5,
                unit: "",
                groupName: "Material",
                levels: "",
            },
            {
                label: "Material Sitzschale",
                labelChanges: "",
                type: "checkbox",
                name: "property_materialSeatShell",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 6,
                unit: "",
                groupName: "Material",
                levels: "",
            },
            {
                label: "Material Tischplatte",
                labelChanges: "",
                type: "checkbox",
                name: "property_tableTopMaterial",
                active: true,
                showInitial: false,
                position: "",
                group: "",
                groupPosition: 7,
                unit: "",
                groupName: "Material",
                levels: "",
            },
        ],
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },

    {
        label: "Zubehör",
        labelChanges: "",
        type: "checkbox",
        name: "property_accessories",
        active: true,
        showInitial: false,
        position: 11,
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Belastbarkeit kg",
        labelChanges: "",
        type: "checkbox",
        name: "property_loadCapacity",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Auszeichnungen",
        labelChanges: "",
        type: "checkbox",
        name: "property_awards",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Fachböden",
        labelChanges: "",
        type: "checkbox",
        name: "property_shelves",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Fächerzahl",
        labelChanges: "",
        type: "checkbox",
        name: "property_numberOfShelves",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Akustikmaterial",
        labelChanges: "",
        type: "checkbox",
        name: "property_acousticMaterial",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Anschlüsse",
        labelChanges: "",
        type: "checkbox",
        name: "property_connections",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Antrieb",
        labelChanges: "",
        type: "checkbox",
        name: "property_drive",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Anzahl Arbeitsplätze",
        labelChanges: "",
        type: "checkbox",
        name: "property_numberOfWorkstations",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Anzahl Monitore",
        labelChanges: "",
        type: "checkbox",
        name: "property_numberOfMonitors",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Anzahl Sitzplätze",
        labelChanges: "",
        type: "checkbox",
        name: "property_numberOfSeats",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Armlehnen",
        labelChanges: "",
        type: "checkbox",
        name: "property_armrests",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Barierefreiheit",
        labelChanges: "",
        type: "checkbox",
        name: "property_barrierFree",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Befestigungsart",
        labelChanges: "",
        type: "checkbox",
        name: "property_mountingType",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Beleuchtung",
        labelChanges: "",
        type: "checkbox",
        name: "property_lighting",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "CRI - Farbwiedergabe Index",
        labelChanges: "",
        type: "checkbox",
        name: "property_criColorRenderingIndex",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Leuchttechnik",
        labelChanges: "",
        type: "checkbox",
        name: "property_lightingTechnology",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Lichtfarbe in Kelvin",
        labelChanges: "",
        type: "checkbox",
        name: "property_lightColorInKelvin",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Drehbar",
        labelChanges: "",
        type: "checkbox",
        name: "property_rotatable",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Einstellbar",
        labelChanges: "",
        type: "checkbox",
        name: "property_adjustable",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Energieeffizienzklasse",
        labelChanges: "",
        type: "checkbox",
        name: "property_energyEfficiencyClass",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Griffe",
        labelChanges: "",
        type: "checkbox",
        name: "property_handles",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Hängeregistratur",
        labelChanges: "",
        type: "checkbox",
        name: "property_hangingFile",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Hängeschränke",
        labelChanges: "",
        type: "checkbox",
        name: "property_wallCabinets",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Hergestellt in",
        labelChanges: "",
        type: "checkbox",
        name: "property_madeIn",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Kopfstütze",
        labelChanges: "",
        type: "checkbox",
        name: "property_headrest",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Montagezustand",
        labelChanges: "",
        type: "checkbox",
        name: "property_mountingCondition",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Ordnerhöhen",
        labelChanges: "",
        type: "checkbox",
        name: "property_fileHeights",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Plattenstärke",
        labelChanges: "",
        type: "checkbox",
        name: "property_plateThickness",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Polsterung",
        labelChanges: "",
        type: "checkbox",
        name: "property_upholstery",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Rollen",
        labelChanges: "",
        type: "checkbox",
        name: "property_castors",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Rückstellautomatik",
        labelChanges: "",
        type: "checkbox",
        name: "property_automaticReset",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Schirmständer",
        labelChanges: "",
        type: "checkbox",
        name: "property_umbrellaStand",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Schließsystem",
        labelChanges: "",
        type: "checkbox",
        name: "property_lockingSystem",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Verschließbar",
        labelChanges: "",
        type: "checkbox",
        name: "property_lockable",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Schubladenzahl",
        labelChanges: "",
        type: "checkbox",
        name: "property_numberOfDrawers",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Schuhrost",
        labelChanges: "",
        type: "checkbox",
        name: "property_shoeRack",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Sensoren",
        labelChanges: "",
        type: "checkbox",
        name: "property_sensors",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Sitzbank",
        labelChanges: "",
        type: "checkbox",
        name: "property_bench",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Spüle",
        labelChanges: "",
        type: "checkbox",
        name: "property_sink",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Stapelbar",
        labelChanges: "",
        type: "checkbox",
        name: "property_stackable",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Stromversorgung",
        labelChanges: "",
        type: "checkbox",
        name: "property_powerSupply",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Türsystem",
        labelChanges: "",
        type: "checkbox",
        name: "property_doorSystem",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Unterbau",
        labelChanges: "",
        type: "checkbox",
        name: "property_substructure",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Verkettbar",
        labelChanges: "",
        type: "checkbox",
        name: "property_linkable",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Versandpauschale",
        labelChanges: "",
        type: "checkbox",
        name: "detail_shippingSupplier",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Belüftung",
        labelChanges: "",
        type: "checkbox",
        name: "property_ventilation",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Magnethaftend",
        labelChanges: "",
        type: "checkbox",
        name: "property_magnetic",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Energieeffizienzlabel",
        labelChanges: "",
        type: "checkbox",
        name: "property_energyEfficiencyLabel",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Lordosenstütze",
        labelChanges: "",
        type: "checkbox",
        name: "property_lumbarSupport",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Sitzpolster",
        labelChanges: "",
        type: "checkbox",
        name: "property_seatCushion",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Sitztiefenverstellung",
        labelChanges: "",
        type: "checkbox",
        name: "property_seatDepthAdjustment",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Sonderfunktion",
        labelChanges: "",
        type: "checkbox",
        name: "property_specialFunction",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Rollen/Gleiter",
        labelChanges: "",
        type: "checkbox",
        name: "property_castorsGlides",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Tischplatte",
        labelChanges: "",
        type: "checkbox",
        name: "property_tabletop",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Tragkraft kg",
        labelChanges: "",
        type: "checkbox",
        name: "property_loadCapacityKg",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Türausführung",
        labelChanges: "",
        type: "checkbox",
        name: "property_doorDesign",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Vesa",
        labelChanges: "",
        type: "checkbox",
        name: "property_vesa",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Vollauszug",
        labelChanges: "",
        type: "checkbox",
        name: "property_fullExtension",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "akustisch Wirksam",
        labelChanges: "",
        type: "checkbox",
        name: "property_acousticallyEffective",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Besonderheiten",
        labelChanges: "",
        type: "checkbox",
        name: "property_specialFeatures",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
    {
        label: "Mechanik",
        labelChanges: "",
        type: "checkbox",
        name: "property_mechanics",
        active: true,
        showInitial: false,
        position: "",
        group: "",
        groupPosition: "",
        unit: "",
        groupName: "",
        levels: "",
    },
];

export default filtersConfig;
